/* Package JSON Import will be here */
import React from 'react';
import { localize } from 'react-localize-redux';
import { Modal } from 'antd';
import { useSelector } from 'react-redux';
/* Package JSON Import will be here */

/* Project Import will be here */
import { uploadImageToS3 } from 'hooks/awsHelper';
import { errorToast, successToast, checkImageFormat } from "utilities/utils";
/* Project Import will be here */

const ImageUpload = ({ translate, isVisible, setIsVisible, setS3ImageUrl, type, setIsUploading, title }) => {
	const { awsConfig } = useSelector((state) => ({ awsConfig: state.appSettings.awsConfig }));

	const onClose = () => {
		setIsVisible(false);
	};

	const handleUpload = (event) => {
		if (event.files) {
			if (event.files.length !== 0) {
				const file = event.files[0];

				/* Check accept image format */
				if (checkImageFormat(file.type)) {

					/* Show loader during upload images to bucket */
					setIsUploading(true);

					// Type contains the values of Amazon S3 BLOB directory
					// based on the component the request arises from

					uploadImageToS3({
						folderPath: `${awsConfig.TempDir}/`,
						fileName: `${new Date()
							.toISOString()
							.replace(/[^0-9]/g, '')
							.slice(0, -3)}.${file.name.split('.')[1]}`,
						file: file,
						awsConfig: awsConfig,
					})
						.then((data) => {
							let finalUrl = awsConfig.StaticUrl + data.split('amazonaws.com')[1];
							finalUrl = finalUrl.replace(`/${awsConfig.DirectoryAccess}`, '');
							setS3ImageUrl(finalUrl);
							setIsUploading(false);

							/* Image upload success alert */
							successToast({ content: translate('common.alerts.success.imageUploadSuccess') });
						})
						.catch((err) => {
							setIsUploading(false);

							/* Image upload error alert */
							errorToast({ content: translate('common.alerts.error.imageUploadError') });
						});
				}
				else {
					errorToast({ content: translate('common.alerts.error.imageFormatError') });
				}
			}
		}
		onClose();
	};

	return (
		<Modal
			visible={isVisible}
			centered
			title={title}
			closeIcon={<i className="fa fa-times-circle fa-lg modal-close-button-icon" aria-hidden="true" onClick={onClose}></i>}
			footer={null}
			maskClosable={false}
		>
			<div className="drawer-row">
				<label className="row p-2" htmlFor="capture-image">
					<input
						accept="image/*"
						style={{ display: 'none' }}
						id="capture-image"
						type="file"
						capture="environment"
						onChange={(e) => handleUpload(e.target)}
					/>
					<div className="col-2">
						<i className="fa fa-camera pr-2 color-primary complaint-big-icon" aria-hidden="true"></i>
					</div>
					<div className="col-10">
						<span>{translate('common.imageUpload.takePhoto')}</span>
					</div>
				</label>
				<label className="row p-2" htmlFor="upload-image">
					<input
						accept="image/*"
						style={{ display: 'none' }}
						id="upload-image"
						type="file"
						onChange={(e) => handleUpload(e.target)}
					/>
					<div className="col-2">
						<i className="fa fa-upload pr-2 color-primary complaint-big-icon" aria-hidden="true"></i>
					</div>
					<div className="col-10">
						<span>{translate('common.imageUpload.uploadPhoto')}</span>
					</div>
				</label>
			</div>
		</Modal>
	);
};

export default localize(ImageUpload, 'locale');
